export const FULFILLMENT_METHODS = {
  curbside: 'curbside',
  delivery: 'delivery',
  dineIn: 'dine_in',
  pickup: 'pickup',
};

export const KEY_VALUES = {
  enter: 'Enter',
  escape: 'Escape',
};

export const AUTH_MODAL_TYPES = {
  forgotPassword: 'forgotPassword',
  login: 'login',
  resetPassword: 'resetPassword',
  signup: 'signup',
};

export const AUTH_MODAL_HEADERS = {
  signup: {
    linkCopy: 'Log In',
    linkTestId: 'LoginLink',
    subtitle: 'Already have a ChowNow account? ',
    subtitleTestId: 'SignupModalSubheader',
    title: 'Sign Up',
    titleTestId: 'SignupModalHeader',
  },
  login: {
    linkCopy: 'Sign Up',
    linkTestId: 'SignupLink',
    subtitle: "Don't have a ChowNow account? ",
    subtitleTestId: 'LoginModalSubheader',
    title: 'Log In',
    titleTestId: 'LoginModalHeader',
  },
  loginExistingEmail: {
    linkCopy: '',
    linkTestId: 'LoginLink',
    subtitle: 'Please enter your password to finish logging in.',
    subtitleTestId: 'LoginExistingEmailSubheader',
    title: 'Welcome Back',
    titleTestId: 'LoginExistingEmailHeader',
  },
  forgotPassword: {
    title: 'Reset Your Password',
    subtitle:
      'Please enter your email below. We will send you a verification code to reset your password.',
  },
  resetPassword: {
    title: 'Reset Your Password',
    subtitle:
      'Please copy and paste the verification code from your email and enter your new password.',
  },
};

export const DEPLOY_ENVIRONMENTS = {
  prod: 'prod',
  local: 'local',
  staging: 'stg',
  uat: 'uat',
  qa: 'qa',
  qa00: 'qa00',
  qa01: 'qa01',
  qa02: 'qa02',
  qa03: 'qa03',
};

export const MARKETPLACE_ORIGINS = {
  prod: 'www',
  qa: 'marketplace',
};
